import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grouping-filter" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectMultiComponent = _resolveComponent("SelectMultiComponent")!
  const _component_InputBlock = _resolveComponent("InputBlock")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_InputBlock, {
      title: "Группировка 1",
      required: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_SelectMultiComponent, {
          modelValue: _ctx.localFilter.firstGroupingId,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localFilter.firstGroupingId) = $event)),
          options: _ctx.getFilteredFirstGroupOptions,
          placeholder: "Выберите",
          modifier: "rectangular",
          required: "",
          clearClass: "",
          canClear: "",
          disabled: _ctx.disabled
        }, null, 8, ["modelValue", "options", "disabled"])
      ]),
      _: 1
    }),
    _createVNode(_component_InputBlock, { title: "Группировка 2" }, {
      default: _withCtx(() => [
        _createVNode(_component_SelectMultiComponent, {
          modelValue: _ctx.localFilter.secondGroupingId,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localFilter.secondGroupingId) = $event)),
          options: _ctx.getFilteredSecondGroupOptions,
          placeholder: "Выберите",
          modifier: "rectangular",
          clearClass: "",
          canClear: "",
          disabled: _ctx.disabled
        }, null, 8, ["modelValue", "options", "disabled"])
      ]),
      _: 1
    })
  ]))
}